import React from 'react';
import { ProjectDetail } from '../../components/Projects';

const ProjectDetailPage = () => {
  return <ProjectDetail />;
};

export default ProjectDetailPage;


